import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import { Modal } from 'bootstrap';
import 'vue-select/dist/vue-select.css'
import { setupAxiosInterceptors } from './utils/axiosConfig';
import axios from 'axios'
import authService from './auth/authService';
import { authMixin } from './mixins/authMixin'; 
import 'leaflet/dist/leaflet.css';

// Permite que las cookies se envíen con cada solicitud
axios.defaults.withCredentials = true

setupAxiosInterceptors();

// La URL base de la API
// axios.defaults.baseURL = 'http://192.168.0.248:8000';
// axios.defaults.baseURL = 'http://localhost:8000';
axios.defaults.baseURL = 'https://api.division16llc.net/';

// Crea la aplicación de Vue
const app = createApp(App);

// Usa el mixin globalmente en toda la app
app.mixin(authMixin);

// Monta la aplicación con router y store
app.use(store).use(router).mount('#app');
